<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>multiple_stop</mat-icon>
        <div style='font-size: 16px;'>
          Transferências
        </div>
      </div>

    </mat-toolbar>

  </mat-card>


  <mat-card class='header-select'>

    <mat-select (ngModelChange)='selectByProduct($event)' [ngModel]='selectedProduct.id'
      placeholder="Selecione um produto">
      <mat-option *ngFor="let product of products" [value]="product.id">
        {{ product.name }}
      </mat-option>
    </mat-select>

  </mat-card>


  <mat-card>

    <!-- TABLE -->
    <mat-table [dataSource]="dataSource" matSort matSortActive="date_buy" matSortDirection='desc'
      matSortDisableClear='true'>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;'>hourglass_top</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- Date buy Column -->
      <ng-container matColumnDef="date_buy">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Compra </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.date | date: 'dd/MM/yyyy' }}
        </mat-cell>
      </ng-container>

      <!-- Member Column -->
      <ng-container matColumnDef="member">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Usuário </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.member_name }}
        </mat-cell>
      </ng-container>

      <!-- Member Column -->
      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef> Usuário </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.category_name }}
        </mat-cell>
      </ng-container>

      <!-- Total  Column -->
      <ng-container matColumnDef="total">
        <mat-header-cell *matHeaderCellDef> Valor </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.total | currency:'BRL':'':'1.2-2' }}
        </mat-cell>
      </ng-container>

      <!-- Date Received Column -->
      <ng-container matColumnDef="date_received">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Recebido </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf='element.returnCode == "00"'>
            {{ element.payment_date.seconds*1000 | date: 'dd/MM/yyyy' }}
          </span>
          <span *ngIf='element.returnCode == "transfer"'>
            <img src='/assets/images/status/img_red.png'>
          </span>
        </mat-cell>
      </ng-container>


      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- Delete Column -->
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='cancelTransfer(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-delete' style='font-size:1.5em;'>delete_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

</div>